<adapt-objectives-page-navigator buttonText="Create key results for quarterly objectives"
                                 [pageActivationTours]="PageActivationTours"></adapt-objectives-page-navigator>
